<template>
  <div class="upload-report-file">
    <el-upload
        ref="uploadFile"
        action="/api/organization/upload_teacher_eva.json"
        :limit="limitNum"
        :headers="fileUpHeaders"
        :data="fileUpParam"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :on-remove="removeFile"
    >
      <el-button type="primary">
        <span>上传</span>
        <!--<i class="el-icon-upload el-icon&#45;&#45;right"></i>-->
      </el-button>
      <div slot="tip" class="upload-tips">{{msgTips}}</div>
    </el-upload>
  </div>
</template>

<script>
  import {storageData} from "@/assets/js/storage";
  import {uploadTeaEva} from "@/api/training_teacher/api";
  export default {
    name: "upload-file",
    props: {
      fileUrl: {
        required: true,
      }
    },
    data() {
      return {
        fileUpHeaders: {'X-Token': storageData.getToken(),"X-UserType":storageData.getUserType()},
        fileUpParam: {
          word: null
        },
        limitNum: 1,
        msgTips:this.fileUrl ? "上传成功" :"只能上传Word文件",
      };
    },
    methods: {
      beforeUpload(file) {
        const reg = /^.*\.(doc|docx)$/i;
        if(!reg.test(file.name)) {
          this.$message.error("请上传Word文件！");
          return false;
        }
        if(file.size > 20*1024*1024) {
          this.$message.error("文件大小不能超过20M!");
          return false;
        }
        this.$set(this.fileUpParam, "word", file);
      },
      uploadSuccess(res) {
        if(Number(res.status) === 0) {
          this.$emit("update:fileUrl", res.result.word_url);
          this.msgTips="上传成功"
        }else{
          this.$message.error(res.msg);
          this.reset();
        }
      },
      removeFile() {
        this.$emit("update:fileUrl", "");
        this.msgTips="只能上传Word文件"
      },
      reset() {
        this.$refs.uploadFile.clearFiles();
      },
    }
  }
</script>

<style lang="stylus">
  @import '~@/assets/css/variable';
  .upload-report-file {
    .el-upload-list__item-name {
      width: 210px;
      color: $color_text_secondary;
      .el-icon-document {
        color: $color_text_secondary;
      }
    }
  }
</style>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .upload-report-file {
    .upload-tips {
      display: inline-block;
      margin: 0 0 0 10px;
      font-size: $font_size_base;
      color: $color_white;
    }
  }
</style>
